import tokeys from 'tokeys';

export const NotificationMethods = tokeys(['SendEmail', 'SendSms']);
